export default __webpack_public_path__ + "static/media/glove_tactical.c10c8d65.jpg";